import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

const DiscordJoinPage = () => {
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: "radial-gradient(circle at top, #1a1a1a, #000)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#FFD700",
        textAlign: "center",
        zIndex: 2,
        position: "relative",
      }}
    >
      <h1
        style={{
          fontSize: "3em",
          fontWeight: "700",
          textShadow: "2px 2px 10px rgba(255, 215, 0, 0.5)",
        }}
      >
        Welcome to Critical Conquer Discord
      </h1>
      <p
        style={{
          color: "#ccc",
          fontSize: "1.2em",
          marginTop: "10px",
          marginBottom: "25px",
          maxWidth: "600px",
        }}
      >
        Join our community of warriors — events, giveaways, and epic guild wars await.
      </p>

      <Button
        variant="contained"
        onClick={() => window.open("https://discord.com/invite/4fsYVDKDyf", "_blank")}
        sx={{
          backgroundColor: "#FFD700",
          color: "#000",
          fontWeight: "bold",
          fontSize: "1.2em",
          padding: "15px 35px",
          borderRadius: "12px",
          boxShadow: "0 0 20px rgba(255,215,0,0.4)",
          "&:hover": {
            backgroundColor: "#fff",
            boxShadow: "0 0 35px rgba(255,215,0,0.8)",
          },
        }}
      >
        Join Discord
      </Button>
    </Box>
  );
};

export default DiscordJoinPage;
